import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import {
  withContextualAttributeTemplate,
  showContextualAttribute,
  hideContextualAttribute,
  prependAccountAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { APPLY_USERINPUT_TYPES, CONTEXTUAL_ENTITY_TYPE, MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS } from '@bingads-webui-campaign/recommendation-core';

import ViewModel from '../viewmodel/index';
import template from '../template/index.pug';
import { SELECT_TYPE } from '../const';

export class RecommendationReallocateBudgetView extends Backbone.View {
  initialize({
    data,
    i18n,
    deps,
    router,
    isMCC,
    gridView,
    readOnly,
    gridService,
  }) {
    this.opportunityData = _.first(data.Opportunities);
    this.type = data.OpportunityType;
    this.i18n = i18n;
    this.data = data;
    this.deps = deps;
    this.router = router;
    this.isMCC = isMCC;
    this.grid = { gridView };
    this.fromCampaign = _.find(
      this.opportunityData.SuggestedCampaignBudgets,
      campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Surplus
    );
    this.toCampaign = _.find(
      this.opportunityData.SuggestedCampaignBudgets,
      campaign => campaign.BudgetStatus === MOVE_BUDGET_CAMPAIGN_BUDGET_STATUS.Deficit
    );
    this.viewModel = new ViewModel({
      i18n,
      view: this,
      data: this.opportunityData,
      fromCampaign: this.fromCampaign,
      toCampaign: this.toCampaign,
      type: this.type,
      deps,
      readOnly,
    });
    this.timerForPopupContextualAttribute = null;
    this.gridService = gridService;
  }

  get events() {
    return {
      'click .apply': this.apply,
      'click .btn-cancel': this.cancel,
      'mouseover .recommendation-reallocate-budget .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-reallocate-budget .contextual-tooltip': 'hideContextualAttributePopup',
      'click .recommendation-reallocate-budget .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    this.router(e);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.type,
        isExpanding: true,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  render() {
    const {
      i18n,
      type,
      fromCampaign,
      toCampaign,
      opportunityData,
    } = this;
    const fromCampaignEntity = withContextualAttributeTemplate({
      opportunityId: opportunityData.OpportunityId,
      entityName: fromCampaign.CampaignName,
      entityId: fromCampaign.CampaignId,
      entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      status: 'false',
      isExpandingView: true,
      ariaLabel: i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: fromCampaign.CampaignName }),
    });
    const toCampaignEntity = withContextualAttributeTemplate({
      opportunityId: opportunityData.OpportunityId,
      entityName: toCampaign.CampaignName,
      entityId: toCampaign.CampaignId,
      entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      status: 'false',
      isExpandingView: true,
      ariaLabel: i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: toCampaign.CampaignName }),
    });

    const model = _.extend({
      i18n,
      type,
      SELECT_TYPE,
      title: i18n.getString('Recommendation_ReallocateBudgetInline_Title', {
        fromCampaign: this.isMCC ? prependAccountAttribute({
          originEntity: fromCampaignEntity,
          opportunityId: opportunityData.OpportunityId,
          accountName: opportunityData.Target.AccountName,
          accountId: opportunityData.Target.AccountId,
        }) : fromCampaignEntity,
        toCampaign: this.isMCC ? prependAccountAttribute({
          originEntity: toCampaignEntity,
          opportunityId: opportunityData.OpportunityId,
          accountName: opportunityData.Target.AccountName,
          accountId: opportunityData.Target.AccountId,
        }) : toCampaignEntity,
      }),
    });
    this.$el.html(template(model));

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  apply() {
    const {
      i18n,
      type,
      fromCampaign,
      toCampaign,
      opportunityData,
    } = this;

    if (_.isEmpty(this.viewModel.applyBudget())) {
      this.viewModel.hadInput(true);
      this.viewModel.errorMessage(i18n.getString('ErrorMessage_InputNumericValue'));
      return;
    }

    const odataType = APPLY_USERINPUT_TYPES[type];
    const { OpportunityId } = opportunityData;
    const applyBudget = i18n.parseDecimal(this.viewModel.applyBudget());
    const userInputs = {
      '@odata.type': odataType,
      OpportunityId,
      NewCampaignBudgets: [
        {
          CampaignId: fromCampaign.CampaignId,
          NewBudget: Math.round((fromCampaign.CurrentBudget - applyBudget) * 100) / 100,
        },
        {
          CampaignId: toCampaign.CampaignId,
          NewBudget: Math.round((toCampaign.CurrentBudget + applyBudget) * 100) / 100,
        },
      ],
    };
    this.trigger('apply', {
      opportunities: [this.opportunityData],
      userInputs: [userInputs],
    });
  }

  cancel() {
    this.trigger('cancel');
  }

  hasChanged() {
    return this.viewModel.budgetType() !== SELECT_TYPE.SuggestBudget;
  }
}
